import { render, staticRenderFns } from "./RegistrationForm.vue?vue&type=template&id=70ff204e&scoped=true&"
import script from "./RegistrationForm.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RegistrationForm.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./RegistrationForm.vue?vue&type=style&index=0&id=70ff204e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ff204e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70ff204e')) {
      api.createRecord('70ff204e', component.options)
    } else {
      api.reload('70ff204e', component.options)
    }
    module.hot.accept("./RegistrationForm.vue?vue&type=template&id=70ff204e&scoped=true&", function () {
      api.rerender('70ff204e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/lpus/register/index/LpusRegisterContent/components/RegistrationForm/RegistrationForm.vue"
export default component.exports